export const RouteFlagEnum = {
  NOT_SHOW: "Not Show",
  SHOW_ROUTE: "Show Route",
  FINISH_ROUTE: "Finish Route",
};
